import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function DespreMission() {
  const transformations = [{
    from: 'Blocaje interioare',
    to: 'Libertate emoțională'
  }, {
    from: 'Stres și neajuns',
    to: 'Abundență în toate ariile vieții'
  }, {
    from: 'Confuzie și stagnare',
    to: 'Claritate și liniște interioară'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1211">
      <div className="max-w-5xl mx-auto px-6" data-id="element-1212">
        <SectionHeading title="Misiunea mea" data-id="element-1213" />

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-1214">
          {transformations.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-cream rounded-3xl p-6 lg:p-8 border border-brand-text/5" data-id="element-1215">
              <div className="space-y-4" data-id="element-1216">
                <div data-id="element-1217">
                  <span className="block text-xs uppercase tracking-wider font-bold text-brand-textSec/70 mb-2" data-id="element-1218">
                    De la
                  </span>
                  <p className="font-heading text-lg text-brand-text/60 line-through decoration-2 decoration-brand-text/30" data-id="element-1219">
                    {t.from}
                  </p>
                </div>
                <ArrowRight className="w-6 h-6 text-brand-gold" data-id="element-1220" />
                <div data-id="element-1221">
                  <span className="block text-xs uppercase tracking-wider font-bold text-brand-gold mb-2" data-id="element-1222">
                    La
                  </span>
                  <p className="font-heading font-bold text-xl text-brand-text" data-id="element-1223">
                    {t.to}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="bg-brand-purple/5 border border-brand-purple/15 rounded-3xl p-8 md:p-12" data-id="element-1224">
          <p className="text-lg md:text-xl text-brand-text/85 leading-relaxed" data-id="element-1225">
            Ghidez oameni care simt că viața lor poate fi mai bună, dar nu știu
            de unde să înceapă. Oameni care se confruntă cu blocaje emoționale,
            o relație dificilă cu banii, stres sau lipsă de încredere. Prin
            cursurile Academia de Abundență și prin sesiuni individuale, îi
            ghidez pas cu pas să identifice credințele din subconștient care îi
            țin pe loc, să le transforme și să creeze o viață fără stres, plină
            de abundență și prosperitate.{' '}
            <strong className="text-brand-purple" data-id="element-1226">
              Predau într-un mod simplu, clar și structurat, cu multă iubire.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}